import React from 'react';
import { Router, Link, browserHistory } from 'react-router';
import { Meteor } from 'meteor/meteor';

import {
  Button,
  FormControl,
  Checkbox
} from '@sketchpixy/rubix';

import { Passengers } from '../../../collections/reservations/passengers';

export class PassengerComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.calculBetterPrice = props.calculBetterPrice;
    }

    removePassenger() {
      Meteor.call('passengers.remove', his.props.passenger._id, (function (err, _id) {
        
          if (err) {
            Messenger().post({
              message: err,
              type: "error"
            });
            return; 
          }

          Messenger().post({
            message: 'Le passagé a bien été supprimé.',
            type: "success"
          });

        }));
    }

	changePassengerInfos(target, event) {
		let update = {};
		update[target] = event.target.value;

		Passengers.update(event.target.id, { "$set": update});
	}

    renderPrice() {
      return (
          <span>{this.calculBetterPrice(this.props.passenger)}€</span>
        );
    }

  	render() {
  	  	return (
			<tr>
				<td><FormControl type="text" id={this.props.passenger._id} ref="passenger_lastName" defaultValue={this.props.passenger.lastName} onChange={this.changePassengerInfos.bind(this, 'lastName')}/></td>
				<td><FormControl type="text" id={this.props.passenger._id} ref="passenger_firstName" defaultValue={this.props.passenger.firstName} onChange={this.changePassengerInfos.bind(this, 'firstName')}/></td>
				<td><FormControl type="text" id={this.props.passenger._id} ref="passenger_age" defaultValue={this.props.passenger.age} onChange={this.changePassengerInfos.bind(this, 'age')}/></td>
				<td><FormControl type="text" id={this.props.passenger._id} ref="passenger_weight" defaultValue={this.props.passenger.weight} onChange={this.changePassengerInfos.bind(this, 'weight')}/></td>
				<td><FormControl type="text" id={this.props.passenger._id} ref="passenger_phone" defaultValue={this.props.passenger.phone} onChange={this.changePassengerInfos.bind(this, 'phone')}/></td>
				<td><FormControl type="text" id={this.props.passenger._id} ref="passenger_email" defaultValue={this.props.passenger.email} onChange={this.changePassengerInfos.bind(this, 'email')}/></td>
				<td><FormControl type="text" id={this.props.passenger._id} ref="passenger_info" defaultValue={this.props.passenger.info} onChange={this.changePassengerInfos.bind(this, 'info')}/></td>
				<td>{this.renderPrice()}</td>
				<td>
					<FormControl id={this.props.passenger._id} defaultValue={this.props.passenger.mobility} onChange={this.changePassengerInfos.bind(this, 'mobility')}componentClass="select" type="select" ref="passenger_mobility">
						<option value={false}>Non</option>
						<option value={true}>Oui</option>
					</FormControl>
				</td>
			</tr>
  	  	);
  	}
}

PassengerComponent.propTypes = {
  passenger: React.PropTypes.object.isRequired,
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/components/component-passengers-list.js
 **/